module.exports = __webpack_public_path__ + "static/img/torso7.4982174f.jpg";